import './SettingsPrice.scss'

import React from 'react'
import SettingsSelect from './SettingsSelect.js'

import {
  PRICE
} from 'common/constants'

import SpeedBumpBanner from '../ReferralStatus/Common/SpeedBumpBanner.js'

const SettingsPrice = ({dispatch, settings, onSelect}) => {

  const lowVolume = <span className="SettingsSelect__additional SettingsSelect__additional--danger">Low Volume</span>
  const medVolume = <span className="SettingsSelect__additional SettingsSelect__additional--warning">Medium Volume</span>

  const additionalMap = {
    "300-500": medVolume,
    "500-1M": lowVolume,
    "1M+": lowVolume
  }

  return (
    <div className="SettingsPrice">
        {settings.is_budget_overridden && (
            <SpeedBumpBanner
                headlineText="You may receive Market VIP leads that don't match your price range preferences"
                bodyText="Your broker can change your price range preferences for leads purchased through Market VIP. If there is ever an issue, please reach out to your broker."
                type="warning"
            />
        )}
      <div className="Settings__label">Price Categories</div>
      <SettingsSelect multiselect={true} options={PRICE} selected={settings.price_categories} rightAdditionalMap={additionalMap} onClick={onSelect} />
    </div>
  )
}

export default SettingsPrice
